app.controller('cart', ['$scope', '$http', 'ShoppingCart', function($cart, $http, ShoppingCart) {

	const PAYMENT_TYPES = {
		cashondelivery: 'cashondelivery',
		banktransfer: 'banktransfer',
		cash: 'cash'
	};

	const SHIPPING_TYPES = {
		czechpost: 'czechpost',
		czechposttohand: 'czechposttohand',
		messenger: 'messenger',
		czechposttosk: 'czechposttosk',
		inperson: 'inperson'
	};

	const COUNTRIES = {
		cz: 'Česká republika',
		sk: 'Slovenská republika'
	};

	$cart.product = window.cfg.product || {};
	$cart.order = window.cfg.order;
	$cart.prices = window.cfg.prices || {};
	$cart.country = "Česká republika";
	$cart.shipping_type = window.cfg.shipping_type || null;
	$cart.payment_type = window.cfg.payment_type || null;

	// Product image handler
	$cart.setImage = image => $cart.selectedImage = image;

	// Adding / Removing products
	$cart.addItem = function(product) {
		let item;
		if ((item = _.findWhere($cart.order.order_items, {product_id: product.id}))) {
			return $cart.increaseQty(item);
		} else {
			return ShoppingCart.add({
				product_id: product.id,
				quantity: 1}).$promise.then(response => $cart.order = response);
		}
	};

	$cart.removeProduct = item => ShoppingCart.remove(item).$promise.then(response => $cart.order = response);

	$cart.updateItem = item => ShoppingCart.update(item).$promise.then(function(response) {
        return this;
    });

	$cart.increaseQty = (item, index) => {
		item.quantity = Math.min(item.product.stock, item.quantity+1);
		return ShoppingCart.update(item).$promise.then(function(response) {
			return this;
		});
	};

	$cart.decreaseQty = function(item) {
		item.quantity = Math.max(1, item.quantity-1);
		return ShoppingCart.update(item).$promise.then(function(response) {
			return this;
		});
	};

	$cart.productAvailable = function(product) {
		const item = _.findWhere($cart.order.order_items, {product_id: product.id});
		if (item) {
			return (product.stock - item.quantity) > 0;
		} else {
			return product.stock > 0;
		}
	};

	// Order helper methods
	$cart.subtotal = function() {
		let subtotal = 0;
		angular.forEach($cart.order.order_items, function(item) {
			if ((typeof item.quantity !== 'undefined') && (item.quantity !== null)) {
				return subtotal += item.quantity * item.product.price;
			}
		});
		return subtotal.toFixed(0);
	};

	// Order helper methods
	$cart.total = () => parseFloat($cart.subtotal()) + parseFloat($cart.order.shipping || 0);

	$cart.totalItems = function() {
		let totalItems = 0;
		angular.forEach($cart.order.order_items, function(item) {
			if ((typeof item.quantity !== 'undefined') && (item.quantity !== null)) {
				return totalItems += item.quantity;
			}
		});
		return totalItems;
	};

	$cart.shippingTypeAvailable = function(type) {
		if (!$cart.country) { return true; }
		if (($cart.country === COUNTRIES.sk) && (type !== SHIPPING_TYPES.czechposttosk)) { return false; }
		if (($cart.country === COUNTRIES.cz) && (type === SHIPPING_TYPES.czechposttosk)) { return false; }
		return true;
	};

	$cart.paymentTypeAvailable = function(type) {
		if (($cart.shipping_type !== SHIPPING_TYPES.inperson) && (type === PAYMENT_TYPES.cash)) { return false; }
		if (($cart.shipping_type === SHIPPING_TYPES.inperson) && (type !== PAYMENT_TYPES.cash)) { return false; }
		return true;
	};

	$cart.$watch('country', function(newVal, oldVal) {
		if (!oldVal) {
			$cart.shipping_type = null;
		}
		if (newVal === COUNTRIES.sk) {
			return $cart.shipping_type = SHIPPING_TYPES.czechposttosk;
		}
	});

	$cart.$watch('shipping_type', function(newVal, oldVal) {
		if (!$cart.prices) { return; }
		if (oldVal === SHIPPING_TYPES.inperson) {
			$cart.payment_type = null;
		}
		if (newVal === SHIPPING_TYPES.inperson) {
			$cart.payment_type = PAYMENT_TYPES.cash;
		}
		return $cart.order.shipping = $cart.prices[$cart.shipping_type] + ($cart.prices[$cart.payment_type] || 0);
	});

	$cart.$watch('payment_type', function() {
		if (!$cart.prices) { return; }
		return $cart.order.shipping = $cart.prices[$cart.payment_type] + ($cart.prices[$cart.shipping_type] || 0);
	});

	$cart.$onInit = function() {
		return this;
	};

	return window.$cart = $cart;
}
]);
